import React from "react";
import styles from "./portrait.module.css";
import { LOCALES } from "../../../constants";

export default function Portrait({ lang, savior, isSmall = false }) {
    const eng = savior.attr.replace("NUAT_", "").toLowerCase();

    return (
        <img
            className={`${styles["portrait"]} ${styles[`${eng}`]} ${isSmall ? `${styles["small"]}` : ""}`}
            alt={savior.name[lang]}
            src={`${process.env.PUBLIC_URL}/images/icon/portrait/${savior.name[LOCALES.KO]}(${savior.title[LOCALES.KO]}).webp`}
        />
    );
}
